export default __webpack_public_path__ + "static/media/ikara_icon.bb34afa8.png";